import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import en from './lang/en'
import PrimeVue from 'primevue/config';

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    'en': en
  },
  silentTranslationWarn: true
})

const loadedLanguages = ['en']

function setI18nLanguage (langLocale) {
  let lang = langLocale.split('-')[0]
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

function setDefaultCalendarLocale() {
  import(`./lang/${i18n.locale}`).then(msgs => {
    Vue.use(PrimeVue, {
      locale: msgs
    })
  })
}

i18n.setLanguage = function setLanguage (langLocale) {
  let lang = langLocale.split('-')[0]
  if (i18n.locale !== lang) {
    if (loadedLanguages.indexOf(lang) < 0) {
      return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        Vue.prototype.$moment.updateLocale(lang, { week: { dow: 0 } });
        Vue.use(PrimeVue, {
          locale: msgs
        })
        return setI18nLanguage(lang)
      }).catch(()=> {
        Vue.prototype.$moment.updateLocale('en', { week: { dow: 0 } });
        setI18nLanguage('en')
      })
    }
  }
  setDefaultCalendarLocale()
  setI18nLanguage(lang)
  return Promise.resolve(lang)
}

export default i18n
